import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { usePayment } from 'pages/PagePayment/hooks/usePayment';
import { closePopupAction } from 'store/modals-reducer/modals.reducer';
import { EPaymentType } from 'store/payment-reducer/payment.reducer';
import { useAppDispatch } from 'store/store';

import * as S from './PaymentConfirmationPopupContent.styled';

export const PaymentConfirmationPopupContent: FC = () => {
  const dispatch = useAppDispatch();
  const { handlePaymentButtonClick } = usePayment();
  const { t } = useTranslation();

  return (
    <S.PaymentConfirmationPopupContent>
      <S.ConfirmationText>{t('payment.btcPaymentConfirmationText')}</S.ConfirmationText>
      <S.ButtonsContainer>
        <S.ConfirmButton
          text={t('payment.Confirm')}
          variant="primary"
          onClick={() => {
            dispatch(closePopupAction());
            handlePaymentButtonClick(EPaymentType.Balance);
          }}
        />
        <S.CancelButton
          text={t('payment.Cancel')}
          variant="bordered"
          onClick={() => {
            dispatch(closePopupAction());
          }}
        />
      </S.ButtonsContainer>
    </S.PaymentConfirmationPopupContent>
  );
};
